<script>
    import Scene from "./Scene.svelte";
    import TelescopeLighthouse from "../pre-comps/Elements/TelescopeLighthouse.svelte";

    const layers = [
        TelescopeLighthouse,
    ];
</script>

<Scene layers={layers}></Scene>